<div
  *ngIf="callService.isMinimized && callService.room"
  #pipStrip
  class="pip-strip"
  [style.left.px]="posX"
  [style.top.px]="posY"
  (mousedown)="onDragStart($event)"
  (touchstart)="onTouchStart($event)"
>
  <!-- Video / Avatar -->
  <div class="pip-video-wrap">
    <video
      #remoteVideo
      class="pip-video"
      [class.hidden]="!hasRemoteVideo"
      autoplay
      playsinline
      muted="false"
    ></video>
    <div *ngIf="!hasRemoteVideo" class="pip-avatar">
      {{ remoteParticipantInitial }}
    </div>
    <!-- Local thumbnail -->
    <video
      #localVideo
      class="pip-local-video"
      autoplay
      playsinline
      muted
    ></video>
  </div>

  <!-- Info -->
  <div class="pip-info">
    <div class="pip-name">{{ remoteParticipantName }}</div>
    <div class="pip-duration">{{ callService.getFormattedDuration() }}</div>
  </div>

  <!-- Controls -->
  <div class="pip-controls">
    <button
      class="pip-btn"
      [class.muted]="!isMicEnabled"
      (click)="toggleMic()"
      title="Toggle mic"
    >
      <i class="fas" [ngClass]="isMicEnabled ? 'fa-microphone' : 'fa-microphone-slash'"></i>
    </button>

    <button
      class="pip-btn"
      [class.muted]="!isCameraEnabled"
      (click)="toggleCamera()"
      title="Toggle camera"
    >
      <i class="fas" [ngClass]="isCameraEnabled ? 'fa-video' : 'fa-video-slash'"></i>
    </button>

    <button class="pip-btn restore-btn" (click)="restore()" title="Expand call">
      <i class="fas fa-expand-alt"></i>
    </button>

    <button class="pip-btn danger-btn" (click)="leave()" title="End call">
      <i class="fas fa-phone-slash"></i>
    </button>
  </div>
</div>
